import { useReplaceVariablesInString } from '@/plugin-system/runtime/template-variables';
import { VizContainerHeaderProps } from '../header/model';

type VizContainerInterpolatableStrings = Pick<VizContainerHeaderProps, 'title' | 'description'>;

export interface UseVizContainerHeaderInterpolatedStringsProps extends VizContainerInterpolatableStrings {}

export interface UseVizContainerHeaderInterpolatedStringsResults extends VizContainerInterpolatableStrings {}

/**
 * Hook that helps consistently set titles and descriptions for `VizContainer.Header` with strings interpolated to
 * account for variables.
 */
export const useVizContainerHeaderInterpolatedStrings = ({
  title: rawTitle,
  description: rawDescription,
}: UseVizContainerHeaderInterpolatedStringsProps) => {
  const title = useReplaceVariablesInString(rawTitle);
  const description = useReplaceVariablesInString(rawDescription);

  return {
    title,
    description,
  };
};
